// One shared requestAnimationFrame loop for every animated dot canvas on the page.
// Subscribe only from effects or event handlers, never during render.

type TickCallback = (now: number) => void

const callbacks = new Set<TickCallback>()

let frame = 0

const loop = (now: number): void => {
    frame = 0
    callbacks.forEach(callback => callback(now))

    if (callbacks.size > 0 && !frame) frame = requestAnimationFrame(loop)
}

export const subscribeTick = (callback: TickCallback): (() => void) => {
    callbacks.add(callback)

    if (!frame) frame = requestAnimationFrame(loop)

    return () => {
        callbacks.delete(callback)

        if (callbacks.size === 0 && frame) {
            cancelAnimationFrame(frame)
            frame = 0
        }
    }
}
